module.exports = __webpack_public_path__ + "img/beijing-北京.b0d7b3d6.webp";